import type { MutationTree } from 'vuex'
import type { ClientState } from './types'
import { SET_CURRENT_PAGE, GET_LIST_CLIENTS, GET_CLIENT } from './types'

export const mutations: MutationTree<ClientState> = {
  [GET_LIST_CLIENTS](state: ClientState, clients: ClientModel[]) {
    state.clients = clients
  },
  [GET_CLIENT](state: ClientState, application: ClientModel) {
    state.client = application
  },
  [SET_CURRENT_PAGE](state: ClientState, numPage: number) {
    state.currentPage = numPage
  },
}
